export const WA_URL =
  'https://wa.me/56920952752?text=Hola%2C%20quiero%20solicitar%20un%20presupuesto%20gratis%20para%20un%20trabajo%20de%20construcci%C3%B3n'
